import React from 'react'
import { Cell } from 'react-mdl'
import './style.css'

// Components.
import Calculator from 'APP/lib/bonus-calculator';

export default class GearBonuses extends React.Component {

    state = {
        activeWeaponTabId: 0,
        bonusArray: []
    }

    constructor(props) {
        super(props);

        var bonusArray = [];
        bonusArray[0] = {
            ias: 0,
            fcr: 0,
            ds: 0,
            cb: 0,
            fhr: 0,
            frw: 0,
            dr: 0,
            mf: 0,
            gf: 0,
            ll: 0,
            ml: 0
        };
        bonusArray[1] = {
            ias: 0,
            fcr: 0,
            ds: 0,
            cb: 0,
            fhr: 0,
            frw: 0,
            dr: 0,
            mf: 0,
            gf: 0,
            ll: 0,
            ml: 0
        };

        if (props.data.equipped.length > 0) {
            props.data.equipped.map(function (item) {
                if (item.magic_attributes !== undefined) {
                    if (item.equipped_id === 4 || item.equipped_id === 5) { // primary hand
                        Calculator.calculate(bonusArray[0], item.magic_attributes);
                        if (item.main_set_partial_bonuses !== undefined) {
                            Calculator.calculate(bonusArray[0], item.main_set_partial_bonuses);
                        }
                    } else if (item.equipped_id === 11 || item.equipped_id === 12) { // alternative hand
                        Calculator.calculate(bonusArray[1], item.magic_attributes);
                        if (item.secondary_set_partial_bonuses !== undefined) {
                            Calculator.calculate(bonusArray[1], item.secondary_set_partial_bonuses);
                        }
                    } else {
                        Calculator.calculate(bonusArray[0], item.magic_attributes);
                        Calculator.calculate(bonusArray[1], item.magic_attributes);
                        if (item.main_set_partial_bonuses !== undefined) {
                            Calculator.calculate(bonusArray[0], item.main_set_partial_bonuses);
                        }
                        if (item.secondary_set_partial_bonuses !== undefined) {
                            Calculator.calculate(bonusArray[1], item.secondary_set_partial_bonuses);
                        }
                    }
                }
                return true;
            });
        }

        if (props.data.inventory.length > 0) {
            props.data.inventory.map(function (item) {
                // Ok, let's make sure we only count charms those are in charm zone
                if ((item.type === "cm1" || item.type === "cm2" || item.type === "cm3") && item.y > 3 && item.identified === true) {
                    Calculator.calculate(bonusArray[0], item.magic_attributes);
                    Calculator.calculate(bonusArray[1], item.magic_attributes);
                }
                return true;
            });
        }

        if (props.data.set_bonuses.length > 0) {
            for (const [setId, setBonuses] of Object.entries(props.data.set_bonuses[0])) { // eslint-disable-line no-unused-vars
                Calculator.calculate(bonusArray[0], setBonuses);
            }
            for (const [setId, setBonuses] of Object.entries(props.data.set_bonuses[1])) { // eslint-disable-line no-unused-vars
                Calculator.calculate(bonusArray[1], setBonuses);
            }
        }

        this.state = {
            bonusArray: bonusArray,
            activeWeaponTabId: 0
        };
    }

    handleSwitchWeapons(activeWeaponTabId) {
        this.setState({ activeWeaponTabId: activeWeaponTabId });
    }

    render() {
        let fcr = this.state.bonusArray[this.state.activeWeaponTabId].fcr;
        let fhr = this.state.bonusArray[this.state.activeWeaponTabId].fhr;
        let ias = this.state.bonusArray[this.state.activeWeaponTabId].ias;
        let frw = this.state.bonusArray[this.state.activeWeaponTabId].frw;
        let dr = this.state.bonusArray[this.state.activeWeaponTabId].dr;
        let mf = this.state.bonusArray[this.state.activeWeaponTabId].mf;
        let gf = this.state.bonusArray[this.state.activeWeaponTabId].gf;
        let cb = this.state.bonusArray[this.state.activeWeaponTabId].cb;
        let ds = this.state.bonusArray[this.state.activeWeaponTabId].ds;
        let ll = this.state.bonusArray[this.state.activeWeaponTabId].ll;
        let ml = this.state.bonusArray[this.state.activeWeaponTabId].ml;

        return (
            <Cell className="gear-bonuses" col={6} tablet={12} phone={12}>
                <h3 className="underlined">Key bonuses</h3>
                <ul>
                    {(fcr > 0) ?
                        <li className="fcr">Faster cast rate: <span className="bonus-value">{fcr}%</span></li>
                        :
                        null
                    }
                    {(fhr > 0) ?
                        <li className="fhr">Faster hit recovery: <span className="bonus-value">{fhr}%</span></li>
                        :
                        null
                    }
                    {(ias > 0) ?
                        <li className="ias">Increased attack speed: <span className="bonus-value">{ias}%</span></li>
                        :
                        null
                    }
                    {(frw > 0) ?
                        <li className="frw">Faster run/walk: <span className="bonus-value">{frw}%</span></li>
                        :
                        null
                    }
                    {(dr > 0) ?
                        <li className="dr">Damage reduced by: <span className="bonus-value">{dr}%</span></li>
                        :
                        null
                    }
                    {(mf > 0) ?
                        <li className="mf">Better chance of getting magic items: <span className="bonus-value">{mf}%</span></li>
                        :
                        null
                    }
                    { (gf > 0) ?
                        <li className="gf">Extra Gold from Monsters: <span className="bonus-value">{gf}%</span></li>
                        :
                        null
                    }
                    {(cb > 0) ?
                        <li className="cb">Crushing blow: <span className="bonus-value">{cb}%</span></li>
                        :
                        null
                    }
                    {(ds > 0) ?
                        <li className="ds">Deadly strike: <span className="bonus-value">{ds}%</span></li>
                        :
                        null
                    }
                    {(ll > 0) ?
                        <li className="ll">Life Stolen Per Hit: <span className="bonus-value">{ll}%</span></li>
                        :
                        null
                    }
                    {(ml > 0) ?
                        <li className="ml">Mana Stolen Per Hit: <span className="bonus-value">{ml}%</span></li>
                        :
                        null
                    }
                </ul>
            </Cell >
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/character/gear-bonuses/index.js